export default "__VITE_ASSET__CEphrOqN__"